var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"task-timestamp"},[_vm._v(" "+_vm._s(_vm._f("formatDateShort")(_vm.dateUpdated))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }